/**
 * @generated SignedSource<<a7f06b4ed04c73d79b9497ad9e3df63e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MyPageSpotRole = "Buyer" | "Frontpage" | "PotentialBuyer" | "Seller";
import { FragmentRefs } from "relay-runtime";
export type myPageSpotsEntity$data = {
  readonly spots: ReadonlyArray<{
    readonly entries: ReadonlyArray<{
      readonly id: string;
      readonly imageUrl: string | null | undefined;
      readonly linkUrl: string | null | undefined;
      readonly width: number | null | undefined;
    } | null | undefined> | null | undefined;
    readonly myPageSpotRole: MyPageSpotRole;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "myPageSpotsEntity";
};
export type myPageSpotsEntity$key = {
  readonly " $data"?: myPageSpotsEntity$data;
  readonly " $fragmentSpreads": FragmentRefs<"myPageSpotsEntity">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "myPageSpotsEntity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MyPageSpot",
      "kind": "LinkedField",
      "name": "spots",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "myPageSpotRole",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MyPageSpotEntry",
          "kind": "LinkedField",
          "name": "entries",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "imageUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "ac2092fc721b21385eb0e56b3ed4dfce";

export default node;
